// extracted by mini-css-extract-plugin
export var completionBody = "_m4-2";
export var completionCard = "_m4-0";
export var completionFooter = "_m4-3";
export var completionTitle = "_m4-1";